<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Rule from "kkk-validate";
export default {
  name: "App",
  beforeMount() {
    Rule.showMessage = (error) => {
      this.$message({
        message: error,
        type: "warning",
      });
    };
  },
};
</script>
<style>
.el-image-viewer__wrapper .el-image-viewer__close {
  top: 95px;
  /* background-color: #fff; */
}
</style>